import { makeObservable, observable, runInAction } from 'mobx';

export enum MainMenu {
  LAYERS = 'layers',
  NEWS = 'news',
  EVENTS = 'events',
  STATISTICS = 'statistics',
  SEARCH = 'search',
  ADDRESS_SEARCH = 'addressSearch',
  ROAD_SECTION = 'roadSectionSearch',
  USER_LAYER = 'userLayer',
  GO_TO_COORDINATE = 'goToCoordinate',
}

export enum RouteMenu {
  CAR = 'car',
  BIKE = 'bike',
  WALK = 'foot',
}

// TODO: rename
export class ControllerStore {
  @observable private _mainMenu: MainMenu = MainMenu.LAYERS;
  @observable private _activeRoute: RouteMenu = RouteMenu.CAR;

  constructor() {
    makeObservable(this);
  }

  get mainMenu() {
    return this._mainMenu;
  }

  // TODO: Вынести в стор для построения маршрута
  get activeRoute() {
    return this._activeRoute;
  }

  set mainMenu(value: MainMenu) {
    runInAction(() => (this._mainMenu = value));
  }

  set activeRoute(value: RouteMenu) {
    runInAction(() => (this._activeRoute = value));
  }
}
